import { render, staticRenderFns } from "./canvas-helper-indicator.vue?vue&type=template&id=635b9030&scoped=true&"
import script from "./canvas-helper-indicator.vue?vue&type=script&lang=js&"
export * from "./canvas-helper-indicator.vue?vue&type=script&lang=js&"
import style0 from "./canvas-helper-indicator.vue?vue&type=style&index=0&id=635b9030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b9030",
  null
  
)

export default component.exports